/**
 * Shared rules for admin user management UI.
 */

export function isSuperAdmin(user) {
  return user?.role === "L1";
}

export function isSameUser(targetUser, currentUser) {
  if (!targetUser?._id || !currentUser?._id) return false;
  return String(targetUser._id) === String(currentUser._id);
}

export function canDeleteAdminUser(targetUser, currentUser) {
  if (!targetUser || !currentUser) return false;
  if (isSuperAdmin(targetUser)) return false;
  if (isSameUser(targetUser, currentUser)) return false;
  return true;
}

export function getDeleteDisabledReason(targetUser, currentUser) {
  if (isSuperAdmin(targetUser)) return "Super Admin cannot be deleted";
  if (isSameUser(targetUser, currentUser)) return "You cannot delete your own account";
  return null;
}

export function canEditAccessControl(targetUser) {
  return !isSuperAdmin(targetUser);
}
